import { render, staticRenderFns } from "./Inforact.vue?vue&type=template&id=78043f69&scoped=true"
import script from "./Inforact.vue?vue&type=script&lang=js"
export * from "./Inforact.vue?vue&type=script&lang=js"
import style0 from "./Inforact.vue?vue&type=style&index=0&id=78043f69&prod&scoped=true&lang=css"
import style1 from "./Inforact.vue?vue&type=style&index=1&id=78043f69&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78043f69",
  null
  
)

export default component.exports